<template>
  <div>
    <v-btn
      color="primary"
      class="mb-2 ml-8"
      :disabled="isAllTextFieldDisable || !isDone || isAcceptance"
      @click="isShowAddRepairItemDialog = true"
    >
      {{ $t('common_new') }}
    </v-btn>
    <v-dialog v-model="isShowAddRepairItemDialog" persistent>
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="repairItem">
              <v-row>
                <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <v-checkbox
                    v-model="editedRepairItem.RemoveItem.IsCustomerDevice"
                    :label="$t('quotation_item_is_customer_device')"
                    :disabled="isAcceptance"
                  ></v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  xl="3"
                  lg="3"
                  v-if="editedRepairItem.RemoveItem.IsCustomerDevice"
                >
                  <v-autocomplete
                    v-model="editedRepairItem.RemoveItem.CustomerDeviceType"
                    :items="computedCustomerDeviceTypeList"
                    item-text="Name"
                    item-value="Type"
                    :label="$t('engineer_item_customer_device_type')"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_results')"
                    :disabled="isAcceptance"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <ValidationProvider
                    :name="$t('installation_notice_item_buy_or_rent')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-autocomplete
                      v-model="editedRepairItem.RemoveItem.BuyOrRentType"
                      :items="allBuyOrRentType"
                      item-text="Name"
                      item-value="Type"
                      required
                      :loading-text="$t('common_get_data')"
                      :no-data-text="$t('common_no_results')"
                      :error-messages="errors[0]"
                      @keyup.enter="setRemoveBuyOrRentTypeAutocomplete"
                      ref="removeBuyOrRentTypeAutocomplete"
                      :disabled="isAcceptance"
                    >
                      <template v-slot:label>
                        <span class="red--text">
                          <strong>* </strong>
                        </span>
                        {{ $t('installation_notice_item_buy_or_rent') }}
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-autocomplete
                    :items="bomList"
                    item-text="Name"
                    item-value="Id"
                    return-object
                    v-model="editedRepairItem.RemoveItem.BomId"
                    @change="setEditedRepairItemBomId"
                    :disabled="isAcceptance"
                    label="Bom名稱"
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ data.item.Name }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ data.item.Describe }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedRepairItem.RemoveItem.BomDescribe"
                    label="Bom描述"
                    disabled
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-checkbox
                    v-model="editedRepairItem.RemoveItem.IsNeedThrowResume"
                    label="確定轉拋履歷卡"
                    :disabled="isAcceptance"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <resume-item-filter-all-type-autocomplete
                    :fatherEditedItem="editedRepairItem.RemoveItem"
                    :editedItemIndex="editedRepairItemIndex"
                    :itemName="'quotation_item_number'"
                    :customerDeviceType="editedRepairItem.RemoveItem.CustomerDeviceType"
                    @setEditedItem="setEditedItem"
                    :isAllTextFieldDisable="isAllTextFieldDisable"
                    v-if="editedRepairItemIndex === -1"
                    refName="itemAutocomplete"
                    @keyupEnter="focusNextInput"
                  />
                  <ValidationProvider
                    :name="$t('quotation_item_number')"
                    rules="required"
                    v-slot="{ errors }"
                    v-else
                  >
                    <v-text-field
                      v-model="editedRepairItem.RemoveItem.Number"
                      :label="$t('quotation_item_number')"
                      disabled
                      :error-messages="errors[0]"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <ValidationProvider
                    :name="$t('quotation_item_name')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="editedRepairItem.RemoveItem.Name"
                      :label="$t('quotation_item_name')"
                      disabled
                      :error-messages="errors[0]"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <ValidationProvider
                    :name="$t('quotation_item_unit')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      v-model="editedRepairItem.RemoveItem.Unit"
                      :label="$t('quotation_item_unit')"
                      required
                      disabled
                      :error-messages="errors[0]"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedRepairItem.RemoveItem.Number"
                    :label="$t('quotation_item_number')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedRepairItem.RemoveItem.Name"
                    :label="$t('quotation_item_name')"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedRepairItem.RemoveItem.Unit"
                    :label="$t('quotation_item_unit')"
                    disabled
                  ></v-text-field>
                </v-col>

              </v-row> -->
              <v-row>
                <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedRepairItem.RemoveItem.Quantity"
                    :label="$t('quotation_item_quantity')"
                    :disabled="isAcceptance"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedRepairItem.RemoveItem.RealQuantity"
                    :label="$t('installation_acceptance_item_real_quantity')"
                    :disabled="isAcceptance"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  editedRepairItem.RemoveItem &&
                    editedRepairItem.RemoveItem.HasSerialNumber &&
                    (!editedRepairItem.RemoveItem.IsCustomerDevice ||
                      (editedRepairItem.RemoveItem.IsCustomerDevice &&
                        editedRepairItem.RemoveItem.CustomerDeviceType === 3))
                "
              >
                <!-- <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedRepairItem.RemoveItem.OriginalSerialNumber"
                    :label="$t('engineer_item_original_serial_numbers')"
                    disabled
                    v-if="editedRepairItem.RemoveItem.SerialNumber"
                  ></v-text-field>
                </v-col> -->
                <!-- <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedRepairItem.RemoveItem.SerialNumber.Number"
                    :label="$t('quotation_item_serialnumber')"
                    :disabled="isAcceptance"
                    v-if="editedRepairItem.RemoveItem.SerialNumber"
                  ></v-text-field>
                </v-col> -->
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-autocomplete
                    v-model="editedRepairItem.RemoveItem.SerialNumber"
                    :items="throwResumeList"
                    item-text="Number"
                    item-value="Number"
                    :label="$t('quotation_item_serialnumber')"
                    required
                    return-object
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_results')"
                    v-if="!isAcceptance"
                    @click="getItemSerialNumber"
                  >
                  </v-autocomplete>
                  <v-text-field
                    v-model="editedRepairItem.RemoveItem.SerialNumber.Number"
                    :label="$t('quotation_item_serialnumber')"
                    disabled
                    v-else
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <v-autocomplete
                    v-model="editedRepairItem.RemoveItem.InstallPosition"
                    :items="allInstallPositionType"
                    item-text="Name"
                    item-value="Type"
                    :label="$t('quotation_item_install_position')"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_results')"
                    :disabled="isAcceptance"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <v-autocomplete
                    v-model="editedRepairItem.RemoveItem.Custody"
                    :items="allCustodyType"
                    item-text="Name"
                    item-value="Type"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_results')"
                    :disabled="isAcceptance"
                    :label="$t('resume_item_custody')"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                  <v-checkbox
                    v-model="editedRepairItem.RemoveItem.IsPersonalFactor"
                    label="人為"
                    :disabled="isAcceptance"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row v-if="editedRepairItem.RemoveItem.HasAuthorize">
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-autocomplete
                    :items="gmTypeList"
                    item-text="Name"
                    item-value="Type"
                    :loading-text="$t('common_get_data')"
                    :no-data-text="$t('common_no_results')"
                    v-model="editedRepairItem.RemoveItem.GmServerType"
                    label="GM"
                    :disabled="isAcceptance"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                  <v-text-field
                    v-model="editedRepairItem.RemoveItem.AuthorizeItemSerialNumber"
                    label="授權序號"
                    disabled
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="editedRepairItem.Reason">
                <v-col>
                  <ValidationProvider
                    :name="$t('installation_acceptance_item_reason')"
                    rules="required"
                    v-slot="{ errors }"
                    v-if="
                      editedRepairItem.RemoveItem.Quantity * 1 !==
                        editedRepairItem.RemoveItem.RealQuantity * 1
                    "
                  >
                    <v-textarea
                      outlined
                      v-model="editedRepairItem.Reason"
                      :error-messages="errors[0]"
                      :disabled="isAcceptance"
                    >
                      <template v-slot:label>
                        <span class="red--text">
                          <strong>* </strong>
                        </span>
                        {{ $t('installation_acceptance_item_reason') }}
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                  <ValidationProvider
                    name="換GM Server原因"
                    rules="required"
                    v-slot="{ errors }"
                    v-else
                  >
                    <v-textarea
                      outlined
                      v-model="editedRepairItem.Reason"
                      :error-messages="errors[0]"
                      disabled
                    >
                      <template v-slot:label>
                        <span class="red--text">
                          <strong>* </strong>
                        </span>
                        換GM Server原因
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="closeEditRepairItem">
            {{ $t('common_cancel') }}
          </v-btn>
          <v-btn color="green darken-1" text @click="addRepairItem">
            {{ $t('common_confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  HttpInstallationAcceptance,
  HttpQuotation,
  HttpInstallPosition,
  HttpFix,
  HttpAuthorizeMapping,
  HttpBom,
  HttpSerialNumber
} from '@/js/http-Manager'
import ResumeItemFilterAllTypeAutocomplete from '@/components/ResumeItemFilterAllTypeAutocomplete.vue'
export default {
  components: { ResumeItemFilterAllTypeAutocomplete },
  name: 'AddRemoveItem',
  props: {
    isDone: {
      type: Boolean,
      default: false
    },
    isAcceptance: {
      type: Boolean,
      default: false
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    itemSerialNumberList: [],
    bomList: [],
    gmTypeList: [],
    searchRepairItems: '',
    isShowAddRepairItemDialog: false,
    allBuyOrRentType: [],
    customerDeviceTypeList: [],
    allInstallPositionType: [],
    editedRepairItemIndex: -1,
    editedRepairItem: {
      RemoveItem: {
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        OriginalSerialNumber: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 1,
        IsPersonalFactor: false,
        CustomerDeviceType: 0,
        IsNeedThrowResume: true
      },
      ReturnItem: {
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 2,
        CustomerDeviceType: 0,
        IsNeedThrowResume: true
      },
      Reason: ''
    },
    defaultRepairItem: {
      RemoveItem: {
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        OriginalSerialNumber: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 1,
        IsPersonalFactor: false,
        CustomerDeviceType: 0,
        IsNeedThrowResume: true
      },
      ReturnItem: {
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 2,
        CustomerDeviceType: 0,
        IsNeedThrowResume: true
      },
      Reason: ''
    },
    selectNeedThrowItem: [],
    allCustodyType: []
  }),
  async mounted () {
    await this.getAllBoms()
    await this.getBuyOrRentType()
    await this.getAllInstallPositionType()
    await this.getCustomerDeviceType()
    await this.getAllCustodyType()
    await this.getGmTypeList()
  },
  watch: {},
  computed: {
    throwResumeList () {
      var array = []
      this.itemSerialNumberList.forEach((element) => {
        if (element.IsUsed) {
          array.push(element)
        }
      })
      return array
    },
    computedCustomerDeviceTypeList () {
      let array = []
      if (this.editedRepairItem.RemoveItem.Number.includes('RA400')) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (this.editedRepairItem.RemoveItem.HasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }

      return array
    }
  },
  methods: {
    async getItemSerialNumber () {
      let param = {
        itemId: this.editedRepairItem.RemoveItem.ItemId
      }
      let response = await HttpSerialNumber.GetSerialNumberFromItemId(param)
      this.itemSerialNumberList = response.status === 200 ? response.data.Data : []
    },
    setEditedItem (val) {
      this.editedRepairItem.RemoveItem.ItemId = val.Id
      this.editedRepairItem.RemoveItem.Number = val.Number
      this.editedRepairItem.RemoveItem.Name = val.Name
      this.editedRepairItem.RemoveItem.Unit = val.Unit
      this.editedRepairItem.RemoveItem.Price = val.Price
      this.editedRepairItem.RemoveItem.IsMonthItem = val.IsMonthItem
      this.editedRepairItem.RemoveItem.IsDelete = val.IsDelete
      this.editedRepairItem.RemoveItem.StoreNo = val.StoreNo
      this.editedRepairItem.RemoveItem.RepairPrice = val.RepairPrice
      this.editedRepairItem.RemoveItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedRepairItem.RemoveItem.RentWarrantyPeriod = val.RentWarrantyPeriod
      this.editedRepairItem.RemoveItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedRepairItem.RemoveItem.HasSerialNumber = val.HasSerialNumber
      this.editedRepairItem.RemoveItem.HasAuthorize = val.HasAuthorize
      this.editedRepairItem = JSON.parse(JSON.stringify(this.editedRepairItem))
    },
    setEditedRepairItemBomId () {
      if (this.editedRepairItem.RemoveItem.BomId) {
        this.editedRepairItem.RemoveItem.BomName = this.editedRepairItem.RemoveItem.BomId.Name
        this.editedRepairItem.RemoveItem.BomDescribe = this.editedRepairItem.RemoveItem.BomId.Describe
        this.editedRepairItem.RemoveItem.BomId = this.editedRepairItem.RemoveItem.BomId.Id
        this.editedRepairItem = JSON.parse(JSON.stringify(this.editedRepairItem))
      }
    },
    async getAllBoms () {
      let response = await HttpBom.GetAllBoms()
      this.bomList = response && response.status === 200 ? response.data.Data : []
    },
    async getGmTypeList () {
      let response = await HttpAuthorizeMapping.GetGmTypes()
      this.gmTypeList = response.status === 200 ? response.data.Data : []
    },
    async getAllCustodyType () {
      let response = await HttpFix.GetCustodyType()
      this.allCustodyType = response.status === 200 ? response.data.Data : []
    },
    setRemoveBuyOrRentTypeAutocomplete (event) {
      this.$refs.removeBuyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.removeBuyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : 0
    },
    async getBuyOrRentType () {
      let response = await HttpInstallationAcceptance.GetBuyOrRentTypes()
      this.allBuyOrRentType = response.status === 200 ? response.data.Data : []
    },
    async getAllInstallPositionType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionType = response.status === 200 ? response.data.Data : []
    },
    closeEditRepairItem () {
      this.isShowAddRepairItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultRepairItem)
        this.editedRepairItem = JSON.parse(str)
        this.editedRepairItemIndex = -1
      })
    },
    async addRepairItem () {
      const isValid = await this.$refs.repairItem.validate()
      if (isValid) {
        this.$emit('setAddRemoveRepairItem', this.editedRepairItem)
        this.closeEditRepairItem()
      }
    }
  }
}
</script>
